module.exports = __webpack_public_path__ + "static/app-icon-dlr-1024-a4bddf5311a19193aa4f57fc867d7e2b.png";